import http from '../utils/request'

/**
 * 用户接口 — 对应后端 UserController (/api/user)
 */

export const getUserList = (params) => http.get('/user', { params })
export const getUsers = (params) => http.get('/user', { params })
export const getUser = (guid) => http.get(`/user/${guid}`)
export const getUserInfo = (account) => http.get(`/user/byAccount/${account}`)
export const saveUser = (user) => http.post('/user', user)
export const deleteUser = (guid) => http.delete(`/user/${guid}`)
export const enableUser = (guid) => http.put(`/user/${guid}/enable`)
export const disableUser = (guid) => http.put(`/user/${guid}/disable`)
export const updateUserPassword = (guid, oldPassword, newPassword) => http.put(`/user/${guid}/password`, { oldPassword, newPassword })

// 部门接口
export const getDepartments = (params) => http.get('/org', { params })
export const getDepartment = (guid) => http.get(`/org/${guid}`)

// 岗位接口
export const getPositions = (params) => http.get('/position', { params })
export const getPosition = (guid) => http.get(`/position/${guid}`)

// 个人信息
export const saveProfile = (data) => http.post('/user/profile', data)
export const uploadAvatar = (formData) => http.post('/user/upload/avatar', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
})
export const uploadSignature = (formData) => http.post('/user/upload/signature', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
})

// 导出 Excel
export const exportUsers = () => http.get('/user/export', { responseType: 'blob' })
